import type { ButtonProps as AntdButtonProps } from 'antd'
import { Button as AntdButton } from 'antd'
import clsx from 'clsx'

import { createHeapDataAttribute } from '@/heap/createHeapDataAttribute'
import { DefaultHeapAttributes, type HeapAttributesType } from '@/heap/heapAttributes'
import { forwardRef } from 'react'
import styles from './styles.module.scss'

export interface ButtonProps extends AntdButtonProps {
  alignWithoutPadding?: true
  dataAttribute?: HeapAttributesType
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { className, alignWithoutPadding, dataAttribute = DefaultHeapAttributes.button, ...props },
    ref,
  ) => {
    return (
      <AntdButton
        {...props}
        className={clsx(className, { [styles.alignWithoutPadding]: alignWithoutPadding })}
        ref={ref}
        {...createHeapDataAttribute(dataAttribute)}
      />
    )
  },
)
Button.displayName = 'Button'
